import { render, staticRenderFns } from "./initPratiche.vue?vue&type=template&id=73403908&"
import script from "./initPratiche.vue?vue&type=script&lang=js&"
export * from "./initPratiche.vue?vue&type=script&lang=js&"
import style0 from "./initPratiche.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports